import React, { useState } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function KitContents() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const tomos = [{
    title: 'TOMO 1 — FUNDAMENTOS',
    icon: '🏋️',
    items: ['Bases del entrenamiento funcional', 'Técnica correcta', 'Movimientos básicos', 'Prevención de lesiones', 'Introducción a circuitos'],
    highlight: 'Para enseñar con seguridad desde el inicio'
  }, {
    title: 'TOMO 2 — BANCO DE EJERCICIOS',
    icon: '🏋️',
    items: ['Ejercicios por grupos musculares', 'Variantes y adaptaciones', 'Uso de materiales (kettlebell, soga, conos)', 'Clasificación por nivel'],
    highlight: 'Para no repetir nunca más'
  }, {
    title: 'TOMO 3 — CLASES PRINCIPIANTES',
    icon: '🏋️',
    items: ['Circuitos simples', 'Adaptación para alumnos nuevos', 'Estructura de clase', 'Progresión inicial'],
    highlight: 'Para arrancar sin improvisar'
  }, {
    title: 'TOMO 4 — CLASES INTERMEDIAS',
    icon: '🏋️',
    items: ['Circuitos más exigentes', 'Combinaciones de ejercicios', 'Trabajo por estaciones', 'Intensidad progresiva'],
    highlight: 'Para mantener el avance real'
  }, {
    title: 'TOMO 5 — CLASES AVANZADAS',
    icon: '🏋️',
    items: ['HIIT', 'EMOM', 'AMRAP', 'Clases de alto rendimiento'],
    highlight: 'Para diferenciarte como profe'
  }, {
    title: 'TOMO 6 — PROGRAMACIÓN Y PROGRESIÓN',
    icon: '🏋️',
    items: ['Planificación semanal', 'Progresión por niveles', 'Organización de clases', 'Seguimiento de alumnos'],
    highlight: 'Para tener un sistema profesional'
  }];
  return <section className="bg-white py-3 md:py-4 px-3 border-b border-gray-200" data-id="element-66">
      <div className="max-w-2xl mx-auto" data-id="element-67">
        <h2 className="text-xl md:text-2xl font-black text-[#0B1F3A] text-center mb-0.5 uppercase tracking-tight" data-id="element-68">
          📖 QUÉ RECIBÍS
        </h2>
        <p className="text-[#FF6B00] text-center text-xs font-black mb-3 tracking-widest" data-id="element-69">
          (CON ÍNDICE REAL)
        </p>

        <div className="space-y-1.5 mb-3" data-id="element-70">
          {tomos.map((tomo, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="bg-[#F5F5F5] border border-gray-200 rounded-lg overflow-hidden" data-id="element-71">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-2.5 text-left hover:bg-gray-100 transition-colors" data-id="element-72">
                  <span className="font-black text-[#0B1F3A] text-sm flex items-center gap-2" data-id="element-73">
                    <span className="text-lg" data-id="element-74">{tomo.icon}</span> {tomo.title}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} data-id="element-75">
                    <ChevronDown className="w-4 h-4 text-[#FF6B00]" data-id="element-76" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-77">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden" data-id="element-78">
                      <div className="px-2.5 pb-2.5 border-t border-gray-200 bg-white" data-id="element-79">
                        <ul className="grid grid-cols-1 md:grid-cols-2 gap-1 mt-2 mb-2" data-id="element-80">
                          {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-1.5 text-gray-700 font-bold text-xs md:text-sm" data-id="element-81">
                              <Check className="w-4 h-4 text-[#FF6B00] flex-shrink-0" strokeWidth={3} data-id="element-82" />
                              <span data-id="element-83">{item}</span>
                            </li>)}
                        </ul>
                        <div className="bg-[#FFF4ED] border border-[#FF6B00] rounded p-2 text-center" data-id="element-84">
                          <p className="text-[#FF6B00] font-black text-xs" data-id="element-85">
                            👉 {tomo.highlight}
                          </p>
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="text-center bg-[#0B1F3A] border-b-3 border-[#050d1a] rounded-xl p-3 shadow-lg" data-id="element-86">
          <p className="text-base md:text-lg font-black text-white mb-1 uppercase" data-id="element-87">
            🔥 Todo paso a paso, listo para aplicar.
          </p>
          <p className="text-sm font-black text-[#FF6B00]" data-id="element-88">
            👉 Entrás a cada clase con todo resuelto.
          </p>
        </div>
      </div>
    </section>;
}